<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <bookmarks />
    </div>
    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- Meta Celebration Component (Floating) -->
      <div
        v-show="metaBatida && showCelebration"
        class="meta-celebration-overlay"
      >
        <div class="meta-celebration-wrapper">
          <!-- Close Button -->
          <button
            class="close-celebration-btn"
            title="Fechar comemoração"
            @click="closeCelebration"
          >
            ✕
          </button>

          <!-- Floating Emojis -->
          <div class="floating-emojis">
            <span class="emoji emoji-1">🎉</span>
            <span class="emoji emoji-2">🥳</span>
            <span class="emoji emoji-3">💰</span>
            <span class="emoji emoji-4">🚀</span>
            <span class="emoji emoji-5">⭐</span>
            <span class="emoji emoji-6">🎊</span>
          </div>

          <!-- Main Celebration Banner -->
          <div class="celebration-banner">
            <div class="celebration-content">
              <div class="trophy-icon">
                🏆
              </div>
              <div class="celebration-text">
                <h2 class="celebration-title">
                  META ALCANÇADA!
                </h2>
                <p class="celebration-subtitle">
                  Parabéns equipe! 🎯
                </p>
              </div>
              <div class="celebration-effects">
                <div class="sparkle sparkle-1">
                  ✨
                </div>
                <div class="sparkle sparkle-2">
                  ✨
                </div>
                <div class="sparkle sparkle-3">
                  ✨
                </div>
              </div>
            </div>

            <!-- Progress Bar Animation -->
            <div class="progress-celebration">
              <div class="progress-bar-celebration" />
            </div>
          </div>
        </div>
      </div>

      <faturamento-mes-dropdown />
      <dark-Toggler class="d-none d-lg-block" />
      <agendamento-notification-dropdown />
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user }}
            </p>
            <span class="user-status">{{ funcao }}</span>
          </div>
          <b-avatar
            v-if="userPhoto"
            size="40"
            variant="light-primary"
            badge
            :src="userPhoto"
            class="badge-minimal"
            badge-variant="success"
          />
          <b-avatar
            v-else
            size="40"
            variant="light-primary"
            badge
            :text="getInitials(user)"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item
          :to="{ name: 'configuracoes' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Configurações</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Bookmarks from '@core/layouts/components/app-navbar/components/Bookmarks.vue'
import FaturamentoMesDropdown from '@core/layouts/components/app-navbar/components/FaturamentoMesDropdown.vue'
import AgendamentoNotificationDropdown from '@core/layouts/components/app-navbar/components/AgendamentoNotificationDropdown.vue'
import axios from '@/../axios-auth'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    // Navbar Components
    FaturamentoMesDropdown,
    DarkToggler,
    AgendamentoNotificationDropdown,
    Bookmarks,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      metaBatida: false,
      showCelebration: true,
      user: '',
      userId: null,
      funcao: '',
      userPhoto: null,
    }
  },
  async created() {
    this.user = localStorage.getItem('userName')
    this.userId = localStorage.getItem('userId')
    this.funcao = localStorage.getItem('funcao')

    // Checa meta mensal (soma das metas dos credores) e compara com faturamento
    try {
      const hoje = new Date()
      const mes = String(hoje.getMonth() + 1).padStart(2, '0')
      const ano = hoje.getFullYear()

      const headers = {
        Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        accept: 'application/json',
      }

      // Busca metas dos credores e faturamento mensal em paralelo
      const metasPromise = axios.get(`api/v1/dashboard/metas_credores?mes=${mes}&ano=${ano}`, { headers })
      const faturamentoPromise = axios.get('api/v1/dashboard/faturamento/mensal', { headers })

      Promise.all([metasPromise, faturamentoPromise])
        .then(([metasRes, fatRes]) => {
          const metasDados = metasRes.data && metasRes.data.dados ? metasRes.data.dados : []
          const totalMeta = metasDados.reduce((s, it) => s + parseFloat(it.meta || 0), 0)

          const faturamento = Number(fatRes.data && fatRes.data.dados && fatRes.data.dados[0] ? fatRes.data.dados[0].total_faturamento : 0)

          // Salva metaMensal na sessão se desejar expor (opcional)
          sessionStorage.setItem('metaMensal', String(totalMeta))
          if (totalMeta > 0 && faturamento >= totalMeta) {
            this.metaBatida = true
            // Verifica se já foi fechado nesta sessão
            this.showCelebration = !sessionStorage.getItem('metaCelebrationClosed')
          } else {
            this.metaBatida = false
          }
        })
        .catch(() => {
          // Em caso de erro nas APIs, não bater a meta por padrão
          this.metaBatida = false
        })
    } catch (e) {
      // segurança adicional
      this.metaBatida = false
    }

    // FOTO DE PERFIL
    await axios.get(`api/v1/users/exibirFoto/${this.userId}`, {
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        accept: 'application/json',
      },
    }).then(res => {
      this.userPhoto = res.data.dados.image
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
    },
    getInitials(name) {
      return name.split(' ').map(word => word[0]).join('').substring(0, 2)
        .toUpperCase()
    },
    closeCelebration() {
      this.showCelebration = false
      // Opcional: salvar no sessionStorage para não mostrar novamente na sessão
      sessionStorage.setItem('metaCelebrationClosed', 'true')
    },
  },
}
</script>

<style scoped>
/* Celebration Overlay - Independent positioning */
.meta-celebration-overlay {
  position: fixed;
  top: 45px;
  right: 65px;
  z-index: 9999;
  pointer-events: none;
}

.meta-celebration-wrapper {
  position: relative;
  pointer-events: all;
}

/* Close Button */
.close-celebration-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #FF6B6B;
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.close-celebration-btn:hover {
  background: #FF5252;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

/* Celebration Banner */
.celebration-banner {
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF6B6B 100%);
  border-radius: 20px;
  padding: 15px 25px;
  box-shadow: 0 10px 30px rgba(255, 215, 0, 0.4);
  position: relative;
  overflow: hidden;
  animation: celebrationPulse 2s infinite ease-in-out;
  border: 3px solid #FFD700;
  min-width: 280px;
}

.celebration-content {
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
  z-index: 2;
}

.trophy-icon {
  font-size: 2.5rem;
  animation: bounce 1s infinite;
}

.celebration-text {
  text-align: center;
}

.celebration-title {
  color: #fff;
  font-weight: bold;
  margin: 0;
  font-size: 1.4rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  animation: textGlow 2s infinite ease-in-out;
}

.celebration-subtitle {
  color: #fff;
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

/* Floating Emojis */
.floating-emojis {
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 1;
}

.emoji {
  position: absolute;
  font-size: 1.5rem;
  animation: float 3s infinite ease-in-out;
}

.emoji-1 { left: -10px; animation-delay: 0s; }
.emoji-2 { left: 20px; animation-delay: 0.5s; }
.emoji-3 { right: 20px; animation-delay: 1s; }
.emoji-4 { right: -10px; animation-delay: 1.5s; }
.emoji-5 { left: 50%; animation-delay: 2s; }
.emoji-6 { right: 40%; animation-delay: 2.5s; }

/* Sparkles */
.celebration-effects {
  position: relative;
}

.sparkle {
  position: absolute;
  color: #FFD700;
  font-size: 1.2rem;
  animation: sparkle 1.5s infinite ease-in-out;
}

.sparkle-1 { top: -10px; right: -10px; animation-delay: 0s; }
.sparkle-2 { top: 10px; right: -15px; animation-delay: 0.5s; }
.sparkle-3 { top: -5px; right: 10px; animation-delay: 1s; }

/* Progress Bar Animation */
.progress-celebration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(255,255,255,0.3);
  overflow: hidden;
}

.progress-bar-celebration {
  height: 100%;
  background: linear-gradient(90deg, #fff, #FFD700, #fff);
  animation: progressFlow 2s infinite ease-in-out;
}

/* Animations */
@keyframes celebrationPulse {
  0%, 100% { transform: scale(1); box-shadow: 0 10px 30px rgba(255, 215, 0, 0.4); }
  50% { transform: scale(1.05); box-shadow: 0 15px 40px rgba(255, 215, 0, 0.6); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
  60% { transform: translateY(-5px); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 1; }
  25% { transform: translateY(-15px) rotate(5deg); opacity: 0.8; }
  50% { transform: translateY(-25px) rotate(-5deg); opacity: 0.6; }
  75% { transform: translateY(-15px) rotate(3deg); opacity: 0.8; }
}

@keyframes textGlow {
  0%, 100% { text-shadow: 2px 2px 4px rgba(0,0,0,0.3); }
  50% { text-shadow: 2px 2px 10px rgba(255,255,255,0.5), 0 0 20px rgba(255,215,0,0.8); }
}

@keyframes sparkle {
  0%, 100% { opacity: 0; transform: scale(0.8) rotate(0deg); }
  50% { opacity: 1; transform: scale(1.2) rotate(180deg); }
}

@keyframes progressFlow {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Responsive */
@media (max-width: 768px) {
  .meta-celebration-overlay {
    top: 10px;
    right: 10px;
    left: 10px;
  }

  .celebration-banner {
    padding: 10px 15px;
    min-width: auto;
  }

  .celebration-title {
    font-size: 1.1rem;
  }

  .trophy-icon {
    font-size: 2rem;
  }

  .close-celebration-btn {
    width: 25px;
    height: 25px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .celebration-content {
    gap: 10px;
  }

  .celebration-title {
    font-size: 1rem;
  }

  .celebration-subtitle {
    font-size: 0.8rem;
  }
}
</style>
